import SearchField from './SearchField';
import SearchFieldContainer, { OwnProps } from './SearchField.container';

export default SearchFieldContainer(SearchField) as React.ComponentClass<
  OwnProps
>;
